import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Home from "./pages/Home";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import About from "./pages/About";
import ColorShowcase from "./components/ColorShowcase";
import Map from "./pages/Map";
import { PageTracking } from "./hooks/usePageTracking";

function App() {
  return (
    <Router>
      <PageTracking />
      <div className="min-h-screen bg-background">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:id" element={<BlogPost />} />
            <Route path="/about" element={<About />} />
            <Route path="/map" element={<Map />} />
            <Route path="/colors" element={<ColorShowcase />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
